import { Dialog, DialogContent } from "@mui/material";
import { ComponentType } from "react";
import { EntryViewer, EntryViewerProps } from "routes/lenses/lens/case/field/entries/EntryViewer";
import { ContextMode } from "./types";

interface ContextDialogProps {
  open: boolean;
  mode: ContextMode;
  onClose: () => void;
  componentProps: DialogComponentProps;
}
type DialogComponentProps = EntryViewerProps;

const CONTEXT_DIALOGS: { [key in ContextMode]: ComponentType<DialogComponentProps> } = {
  [ContextMode.EntryViewer]: (props) => {
    return <EntryViewer {...props} />;
  },
};

export function ContextDialog({ open, onClose, mode, componentProps }: ContextDialogProps) {
  const Component = CONTEXT_DIALOGS[mode];
  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: "98vw", minHeight: "98vh" } }}>
      {/* Reset padding/margin so component can define their own */}
      <DialogContent className="flex items-stretch p-0 m-0">
        <Component {...componentProps} onClose={onClose} />
      </DialogContent>
    </Dialog>
  );
}
